module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAUBAMAAAAevyJ8AAAAGFBMVEVKrdZLrdVcssCSwIHJ0EDS0Tbt2RX/3gAfmmgCAAAAP0lEQVQY02NgoBYQdksxROYzhZeXlyogCYiWA0EgkoA5SKAYScAdJFCCJJAOEijDJ4ChBcNQDGsxHIbhdAoBADNTGcXM+PqYAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/pw.png
// module id = 907
// module chunks = 0